import authApi from "../../../contextProviders/auth-api";
import {apiList, methodType, userActions} from "../../../contextProviders/constant";

const confirmTerms = async (tokenhandler, onSuccess) => {
  try {
    const response = await authApi({
      body: {
        partner_company_code: "qbo",
        terms_version: "1.0",
      },
      method: methodType.post,
      url: apiList[userActions.qboAcceptTerms],
      tokenhandler,
      isSecured: true,
    });
    const { oauth_url } = response?.data || {};
    if (oauth_url) {
      // Determine language from the current URL path (most reliable source)
      const pathLang = window.location.pathname.split("/")[1];
      const currentLang = (pathLang === "fr" || pathLang === "en") ? pathLang : (localStorage.getItem("lang") || "en");
      const locale = currentLang === "fr" ? "fr-CA" : "en-CA";
      const oauthUrlWithLocale = `${oauth_url}${oauth_url.includes("?") ? "&" : "?"}locale=${locale}`;

      const width = 600;
      const height = 700;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;

      const popup = window.open(
          oauthUrlWithLocale,
          "oauthPopup",
          `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
      );

      if (!popup || popup.closed || typeof popup.closed === "undefined") {
        throw new Error("Popup was blocked. Please allow popups for this site.");
      }

      // Signal that the OAuth flow is happening in a popup so the callback page can detect it
      localStorage.setItem("QBO_OAUTH_POPUP", "true");
      localStorage.removeItem("QBO_OAUTH_CALLBACK_URL");
      await new Promise((resolve) => {
        const startTime = Date.now();
        const cleanup = () => {
          window.removeEventListener("storage", storageHandler);
          clearInterval(pollInterval);
        };

        // The popup's callback page writes the OAuth URL to localStorage and closes itself.
        // The storage event fires in all other same-origin windows when localStorage changes.
        const storageHandler = (event) => {
          if (event.key !== "QBO_OAUTH_CALLBACK_URL" || !event.newValue) return;

          cleanup();
          try { popup.close(); } catch (e) { /* ignore */ }

          const callbackUrl = event.newValue;
          localStorage.removeItem("QBO_OAUTH_CALLBACK_URL");
          localStorage.removeItem("QBO_OAUTH_POPUP");

          if (onSuccess) {
            const currentLang = localStorage.getItem("lang") || "en";
            const url = new URL(callbackUrl);
            const pathSegments = url.pathname.split("/");
            if (pathSegments.length > 1 && (pathSegments[1] === "en" || pathSegments[1] === "fr")) {
              pathSegments[1] = currentLang;
              url.pathname = pathSegments.join("/");
            }
            onSuccess(url.toString());
          }
          resolve();
        };
        window.addEventListener("storage", storageHandler);

        // Poll as a backup for missed storage events and to detect genuine closure.
        const pollInterval = setInterval(() => {
          // Check if the popup wrote the callback URL (catches missed storage events)
          const callbackUrl = localStorage.getItem("QBO_OAUTH_CALLBACK_URL");
          if (callbackUrl) {
            cleanup();
            try { popup.close(); } catch (e) { /* ignore */ }

            localStorage.removeItem("QBO_OAUTH_CALLBACK_URL");
            localStorage.removeItem("QBO_OAUTH_POPUP");

            if (onSuccess) {
              const currentLang = localStorage.getItem("lang") || "en";
              const url = new URL(callbackUrl);
              const pathSegments = url.pathname.split("/");
              if (pathSegments.length > 1 && (pathSegments[1] === "en" || pathSegments[1] === "fr")) {
                pathSegments[1] = currentLang;
                url.pathname = pathSegments.join("/");
              }
              onSuccess(url.toString());
            }
            resolve();
            return;
          }

          // Cross-Origin-Opener-Policy (COOP) headers on Intuit's servers cause
          // popup.closed to return true while the popup is still open (e.g. while
          // the user is on Intuit's login page). Stop polling to allow the loading
          // state to clear, but intentionally keep the storage event listener active
          // so that the callback is still handled when the user finishes logging in
          // and the OAuth flow completes — even if that takes several minutes.
          if (Date.now() - startTime > 30000 && popup.closed) {
            clearInterval(pollInterval);
            resolve();
          }
        }, 1000);
      });

      return;
    }

    throw new Error("OAuth URL not found");
  } catch (error) {
    console.error("Error confirming terms:", error);
    throw error;
  }
};

const helper = { confirmTerms };

export default helper;